const items = [
  "Branded Content",
  "TV Projects",
  "Vertical Drama",
  "Talent Partnerships",
  "Brand Integration",
  "Digital Campaigns",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/5 bg-navy/40 py-6 overflow-hidden">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-syne text-lg sm:text-2xl font-semibold uppercase tracking-[0.15em] text-slate-500 px-8">
                  {item}
                </span>
                <svg viewBox="0 0 20 20" className="w-3.5 h-3.5 text-turq/60" fill="none" aria-hidden>
                  <polygon points="10 1 18.6 5.5 18.6 14.5 10 19 1.4 14.5 1.4 5.5" stroke="currentColor" strokeWidth="1.4" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
